(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ks-approved-visual"] && !Shopify.designMode) return;
  try {
    (()=>{
 function enableLookDrag(){
  document.querySelectorAll('.ks-approved-look-list:not([data-ks-desktop-drag])').forEach(list=>{
   list.dataset.ksDesktopDrag='true';
   let drag=null;
   let suppressClick=false;
   list.addEventListener('dragstart',event=>{
    if(event.target.closest('a,img'))event.preventDefault();
   });
   list.addEventListener('pointerdown',event=>{
    if(event.pointerType!=='mouse'||event.button!==0||!matchMedia('(min-width:750px) and (hover:hover) and (pointer:fine)').matches||list.scrollWidth<=list.clientWidth+1)return;
    drag={pointerId:event.pointerId,x:event.clientX,left:list.scrollLeft,moved:false};
   });
   list.addEventListener('pointermove',event=>{
    if(!drag||event.pointerId!==drag.pointerId)return;
    const delta=event.clientX-drag.x;
    if(!drag.moved&&Math.abs(delta)<5)return;
    if(!drag.moved){drag.moved=true;list.classList.add('is-dragging');list.setPointerCapture(event.pointerId);}
    list.scrollLeft=drag.left-delta;
    event.preventDefault();
   });
   const stop=event=>{
    if(!drag||event.pointerId!==drag.pointerId)return;
    if(drag.moved){suppressClick=true;setTimeout(()=>{suppressClick=false;},0);}
    list.classList.remove('is-dragging');
    drag=null;
   };
   list.addEventListener('pointerup',stop);
   list.addEventListener('pointercancel',stop);
   list.addEventListener('click',event=>{
    if(!suppressClick)return;
    event.preventDefault();event.stopPropagation();suppressClick=false;
   },true);
  });
 }
 function enhance(){
  enableLookDrag();
  document.querySelectorAll('.ks-approved-product').forEach(root=>{
   const quantity=root.querySelector('.product-form__quantity');
   const buttons=root.querySelector('product-form .product-form__buttons');
   if(quantity&&buttons&&!buttons.contains(quantity)){buttons.classList.add('ks-purchase-row');buttons.prepend(quantity);}
   const picker=root.querySelector('variant-selects');
   if(picker){
    picker.querySelectorAll('fieldset').forEach(field=>{
     const name=field.querySelector('input[name]')?.name.toLowerCase()||'';
     field.classList.toggle('ks-metal-field',name.includes('metal'));
     field.classList.toggle('ks-post-field',name.includes('post')&&name.includes('length'));
    });
    const fields=[...picker.querySelectorAll('fieldset')].filter(field=>getComputedStyle(field).display!=='none').sort((a,b)=>Number(getComputedStyle(a).order)-Number(getComputedStyle(b).order));
    const sizeTarget=(fields[1]||fields[0])?.querySelector('.form__label');
    const guide=root.querySelector('.kosiner-size-guide-shell');
    if(guide&&sizeTarget&&!sizeTarget.contains(guide)){picker.querySelectorAll('.ks-inline-size-label').forEach(label=>label.classList.remove('ks-inline-size-label'));sizeTarget.classList.add('ks-inline-size-label');sizeTarget.append(guide);}
   }
   root.querySelectorAll('.product__collapsible .accordion__title').forEach(title=>{const text=title.textContent.trim();if(text&&text===text.toLocaleUpperCase()&&text!==text.toLocaleLowerCase())title.textContent=text.toLocaleLowerCase();});
   root.querySelectorAll('.ks-approved-description:not([data-enhanced])').forEach(box=>{
    box.dataset.enhanced='true';
    const source=box.querySelector('.ks-description-source');
    const fitHeading=[...source.querySelectorAll('h2,h3,h4,h5,h6')].find(h=>/^details\s*&\s*fit$/i.test(h.textContent.trim()));
    if(fitHeading){
     const fit=document.createElement('details');const fitSummary=document.createElement('summary');fitSummary.textContent=fitHeading.textContent;fit.append(fitSummary);
     let next=fitHeading.nextSibling;
     while(next&&!(next.nodeType===1&&next.tagName==='DETAILS')){const move=next;next=next.nextSibling;fit.append(move);}
     fitHeading.replaceWith(fit);
    }
    const details=[...source.querySelectorAll('details')].filter(d=>!d.parentElement.closest('details'));
    const accordion=document.createDocumentFragment();
    const intro=document.createElement('details');
    const summary=document.createElement('summary');summary.textContent=box.dataset.descriptionLabel;intro.append(summary);
    const body=document.createElement('div');body.className='ks-description-body rte';
    details.forEach(d=>{d.open=false;d.removeAttribute('style');const sum=d.querySelector('summary');if(sum)sum.removeAttribute('style');accordion.append(d);});
    while(source.firstChild)body.append(source.firstChild);
    if(body.textContent.trim()||body.querySelector('img,video')){intro.append(body);box.append(intro);}
    source.remove();box.append(accordion);
   });
  });
  document.querySelectorAll('body:has(.ks-approved-product) #MainContent>.shopify-section .global-detail-image').forEach(el=>el.closest('.section-padding')?.classList.add('ks-lower-content'));
  if(window.matchMedia('(max-width:749px)').matches){
   document.querySelectorAll('.jdgm-review-widget.jdgm--done-setup-widget').forEach(widget=>{
    if(!window.jdgm?.$)return;
    widget.querySelectorAll('.jdgm-paginate').forEach(pager=>{window.jdgm.$(pager).data('per-page',4);pager.setAttribute('data-per-page','4');});
    const first=widget.querySelector('.jdgm-paginate__page[data-page="1"]');
    if(first&&!widget.dataset.ksPageSize){
     widget.dataset.ksPageSize='4';
     const pager=first.closest('.jdgm-paginate');
     const total=Number(widget.querySelector('[data-number-of-reviews]')?.dataset.numberOfReviews||0);
     const pages=Math.ceil(total/4);
     if(pages>1){
      const prototype=first.cloneNode(true);const nodes=document.createDocumentFragment();
      const numbers=Array.from({length:Math.min(pages,5)},(_,i)=>i+1);if(pages>5)numbers.push(pages);
      numbers.forEach(page=>{const a=prototype.cloneNode(true);a.dataset.page=page;a.textContent=page;a.classList.toggle('jdgm-curt',page===1);a.setAttribute('aria-label',prototype.getAttribute('aria-label').replace('1',String(page)));if(page!==1)a.removeAttribute('aria-current');nodes.append(a);});
      pager.replaceChildren(nodes);
     }
    }
   });
  }
 }
 let scheduled=false;
 function schedule(){if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;enhance();});}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',enhance);else enhance();
 const observer=new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1)))schedule();});
 observer.observe(document.documentElement,{childList:true,subtree:true});
 document.addEventListener('shopify:section:load',enhance);
 document.addEventListener('input',event=>{if(event.target.matches('.ks-approved-product .quantity__input'))schedule();});
 document.addEventListener('change',event=>{if(event.target.matches('.ks-approved-product .quantity__input'))schedule();});
})();
  } catch(e) { console.error(e); }
})();

})();
